
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/order/document",
      function () {
        return require("private-next-pages/order/document.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/order/document"])
      });
    }
  